"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresentationView = void 0;
const Presentation_1 = require("./Presentation");
/**
 * Created by SH 19/03/2019
 */
class PresentationView extends PIXI.Container {
    get customConfig() { return this._customConfig; }
    get PresentationState() { return this._presentationState; }
    /**
     * Constructor, Checks if this.addEventListeners() has been defined and will trigger it if so.
     * @returns {PresentationView}
    */
    constructor() {
        super();
        /* ---------------------------------------- */
        /* The Core State */
        this._presentationState = new Presentation_1.PresentationState(Presentation_1.PresentationState.INACTIVE);
        if (this.addEventListeners)
            this.addEventListeners();
    }
    /* ---------------------------------------- */
    /* NOTE: this set function should ONLY be used by the PresentationController. */
    set pTimeline(tl) { this.timeline = tl; }
    /**
     * The Core TimeLine that is being handled by the PresentationController that owns the Presentaion.
     *
     * Apply any other TimeLines, tweens and/or function calls to this timeline to fill up the presentation flow.
     * When this Timeline Ends. It will try to Trigger the Stop, but if the function "IsActive" and/or "promiseSync" returns true.
     * This Timeline will Reset itself and ReTrigger Function GetPresentation or EndPresentation.
     *
     * @returns {TimelineMax}.
    */
    get pTimeline() { return this.timeline; }
    /**
     * Use this if you want to use a secondary checker other than function IsActive.
     * This function will only be checked if applied and the presentation has been played ones.
     *
     * @returns {boolean} True = Retrigger the Get/EndPresentation. False = Trigger StopPresentation.
    */
    promiseSync() { return true; }
    /**
     * Use this if you want to Define your own continous activation.
     *
     * NOTE: If this is not being defined. Use "this.PresentationState.Set(this.PresentationState.INACTIVE);"
     * to disable it so it won't get stuck in a infinity loop.
     *
     * This function needs to be true if the presentation should be played.
     *
     * @returns {boolean} True = Retrigger the Get/EndPresentation. False = Trigger StopPresentation.
    */
    isActive() { return (!this.PresentationState.isInactive && !this.PresentationState.isEndState); }
}
exports.PresentationView = PresentationView;
//# sourceMappingURL=PresentationView.js.map